<template>

    <trax-ui-top-box :background-image="registration.program.meta.background" 
        :title1="registration.program.name" :description="registration.program.description"
        :link1="group" :link2="date" >
    </trax-ui-top-box>

</template>

<script>
    export default {

        data: function() {
            return {
                user: user,
                registration: data.registration
            }
        },

        computed: {

            group: function() {
                return {value: this.registration.cohort.name, icon: 'people'};
            },

            date: function() {
                if (!this.registration.start_date) return null;
                return {value: moment(this.registration.start_date).format('DD MMM YYYY'), icon: 'event'};
            }
        }
    }
</script>
